import { render } from "./UsuarioResumenEstadisticasLlamadasGrafica.vue?vue&type=template&id=2d1ad0b5"
import script from "./UsuarioResumenEstadisticasLlamadasGrafica.vue?vue&type=script&lang=js"
export * from "./UsuarioResumenEstadisticasLlamadasGrafica.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__